import React from "react";

const LoaderBox = ({ classe }) => {
  return (
    <li className={`${classe} flex animate-pulse items-center space-x-2`}>
      <p className="h-6 w-8 shrink-0 rounded bg-smoot"></p>
      <p className={`${classe} h-6 rounded bg-smoot`}></p>
    </li>
  );
};

export default LoaderBox;
